import { render, staticRenderFns } from "./LapidusTransactions.vue?vue&type=template&id=8892291c&"
import script from "./LapidusTransactions.vue?vue&type=script&lang=js&"
export * from "./LapidusTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports